export const GET_NOTIFICATION_REQUEST = "GET_NOTIFICATION_REQUEST";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL";

export const MARK_NOTIFICATION_REQUEST = "MARK_NOTIFICATION_REQUEST";
export const MARK_NOTIFICATION_SUCCESS = "MARK_NOTIFICATION_SUCCESS";
export const MARK_NOTIFICATION_FAIL = "MARK_NOTIFICATION_FAIL";
